export const ArmyDataCardContainer = () => {
  return (
   <div
      style={{
        padding: "24px",
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 4px 20px 0 rgba(166, 196, 205, 0.1)",
        maxWidth: 900,
        margin: "32px auto"
      }}
    >
     
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "0 28px",
        //   borderTop: "1px solid #eee"
        }}
      >
        {/* Left column */}
        <div>
        
            <div
            //   key={item.category}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "18px 0",
                // borderBottom:  "1px solid #faf0e6" 
              }}
            >
              <span style={{
                fontSize: "20px",
                color: "#292929"
              }}>
                Total people who have completed counseling sessions
              </span>
              <span style={{
                fontSize: "22px",
                color: "#ff8900",
                fontWeight: 600
              }}>
                282
              </span>
            </div>

             <div
            //   key={item.category}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "18px 0",
                // borderBottom:  "1px solid #faf0e6" 
              }}
            >
              <span style={{
                fontSize: "20px",
                color: "#292929"
              }}>
                People Flagged for Concerns
              </span>
              <span style={{
                fontSize: "22px",
                color: "#ff8900",
                fontWeight: 600
              }}>
                01
              </span>
            </div>
         
          <div
            //   key={item.category}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "18px 0",
                // borderBottom:  "1px solid #faf0e6" 
              }}
            >
              <span style={{
                fontSize: "20px",
                color: "#292929"
              }}>
                People Recommended for Counseling
              </span>
              <span style={{
                fontSize: "22px",
                color: "#ff8900",
                fontWeight: 600
              }}>
                32
              </span>
            </div>
     
        </div>
        
     
      </div>
    </div>
  );
};
